
import * as Vue from "vue";
import { PopoverPanel } from '@headlessui/vue'

export default Vue.defineComponent({
  components: {
    PopoverPanel,
  }
});
